import { Component, OnInit } from "@angular/core";
import { TreeModel, NodeEvent } from "ng2-tree";
declare const alertify: any;
@Component({
  selector: "zl-settings",
  templateUrl: "./settings.component.html",
  styleUrls: ["./settings.component.css"]
})
export class SettingsComponent implements OnInit {
  isCollapsed = false;
  constructor() {}

  ngOnInit() {}
}
